module.exports = __webpack_public_path__ + "img/06688d8.svg";